module.exports = __webpack_public_path__ + "assets/img/label-classify-1.97bc7bc9.png";